import { Route, Routes } from "react-router";
import { NotFound } from "../../../app/pages/NotFound";
import { WILDCARD_ROUTE } from "../../../common/constants";
import { Permission } from "../../../common/security/enums";
import PageWithPermission from "../../auth/components/PageWithPermission";
import { CommissionsBatchDetailContainer } from "./containers/CommissionsBatchDetailContainer";
import { CommissionsBatchInputImportsContainer } from "./containers/CommissionsBatchInputImportsContainer";
import { CommissionsBatchListContainer } from "./containers/CommissionsBatchListContainer";
import { CommissionsBatchManualBailAccountMovementsContainer } from "./containers/CommissionsBatchManualBailAccountMovementsContainer";
import { CommissionsBatchManualDebtAccountMovementsContainer } from "./containers/CommissionsBatchManualDebtAccountMovementsContainer";
import { CommissionsBatchManualImportsContainer } from "./containers/CommissionsBatchManualImportsContainer";
import { CommissionsBatchPostponedCommissionsContainer } from "./containers/CommissionsBatchPostponedCommissionsContainer";
import { CommissionsBatchSpecialCommissionsContainer } from "./containers/CommissionsBatchSpecialCommissionsContainer";
import { COMMISSIONS_BATCH_ROUTE_PATHS } from "./paths";

const routes = () => (
  <Routes>
    <Route
      index
      element={
        <PageWithPermission component={<CommissionsBatchListContainer />} permissions={[Permission.COMMISSIONS]} />
      }
    />

    <Route
      path={COMMISSIONS_BATCH_ROUTE_PATHS.detail.path}
      element={
        <PageWithPermission component={<CommissionsBatchDetailContainer />} permissions={[Permission.COMMISSIONS]} />
      }
    />

    <Route
      path={COMMISSIONS_BATCH_ROUTE_PATHS.inputImports.path}
      element={
        <PageWithPermission
          component={<CommissionsBatchInputImportsContainer />}
          permissions={[Permission.COMMISSIONS]}
        />
      }
    />

    <Route
      path={COMMISSIONS_BATCH_ROUTE_PATHS.manualImports.path}
      element={
        <PageWithPermission
          component={<CommissionsBatchManualImportsContainer />}
          permissions={[Permission.COMMISSIONS]}
        />
      }
    />

    <Route
      path={COMMISSIONS_BATCH_ROUTE_PATHS.postponedCommissions.path}
      element={
        <PageWithPermission
          component={<CommissionsBatchPostponedCommissionsContainer />}
          permissions={[Permission.COMMISSIONS]}
        />
      }
    />

    <Route
      path={COMMISSIONS_BATCH_ROUTE_PATHS.specialCommissions.path}
      element={
        <PageWithPermission
          component={<CommissionsBatchSpecialCommissionsContainer />}
          permissions={[Permission.COMMISSIONS]}
        />
      }
    />

    <Route
      path={COMMISSIONS_BATCH_ROUTE_PATHS.manualBailAccountMovements.path}
      element={
        <PageWithPermission
          component={<CommissionsBatchManualBailAccountMovementsContainer />}
          permissions={[Permission.COMMISSIONS]}
        />
      }
    />

    <Route
      path={COMMISSIONS_BATCH_ROUTE_PATHS.manualDebtAccountMovements.path}
      element={
        <PageWithPermission
          component={<CommissionsBatchManualDebtAccountMovementsContainer />}
          permissions={[Permission.COMMISSIONS]}
        />
      }
    />

    <Route path={WILDCARD_ROUTE} element={<NotFound />} />
  </Routes>
);

export default routes;
